// extracted by mini-css-extract-plugin
module.exports = {"title":"BackSection_title__3Rrt-"};